import logo, { logoVariants, LogoVariantsType } from './logo';
import { CSSStandardProperties } from '../../../types/theme';

export const navVariants = {
  logo: logoVariants,
};

const nav = {
  logo,
};

export type NavVariantsType = 'logo';

export interface NavType {
  /** The Nav subcomponent types. */
  Components: Record<NavVariantsType, Record<LogoVariantsType, CSSStandardProperties>>;
  /** The Nav.Logo component types. */
  Logo: LogoVariantsType;
}

export default nav;
